import { render, staticRenderFns } from "./WidgetNode.vue?vue&type=template&id=2870b737&scoped=true"
import script from "./WidgetNode.vue?vue&type=script&lang=js"
export * from "./WidgetNode.vue?vue&type=script&lang=js"
import style0 from "./WidgetNode.vue?vue&type=style&index=0&id=2870b737&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2870b737",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2870b737')) {
      api.createRecord('2870b737', component.options)
    } else {
      api.reload('2870b737', component.options)
    }
    module.hot.accept("./WidgetNode.vue?vue&type=template&id=2870b737&scoped=true", function () {
      api.rerender('2870b737', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/playerWidgets/WidgetNode.vue"
export default component.exports